import React from "react";
import { MENU_TAB } from "../utilities/Constants";
import NavBar from "./NavBar";
import MenuPdf from "../assets/pdf/Menu-Pizzeria.pdf";
import { FaEye } from "react-icons/fa";

const Menu = () => {
    return (
        <>
            <NavBar activeItem={MENU_TAB} />
            <div className="container mb-5">
                <div className="row mb-3">
                    <div className="col-12 text-center mt-5">
                        <h1>Menu</h1>
                    </div>
                </div>
                <div className="mb-4 colore-primario p-3 text-white rounded ">
                    <h4 className="display-4">Esplora il nostro delizioso menu!</h4>
                    <p className="lead">
                        Siamo dedicati a offrire il massimo della qualità e della soddisfazione ai nostri clienti. Ogni pizza è preparata con cura e passione utilizzando gli ingredienti freschi e genuini. Ci impegniamo a garantire un'esperienza culinaria indimenticabile per tutti i nostri clienti.
                    </p>
                </div>
                <div className="row justify-content-center">
                    <div className="col-sm-12 col-md-8 col-lg-4">
                        <div className="card colore-terziario text-white">
                            <div className="card-body d-flex flex-column justify-content-center align-items-center">
                                <h5 className="card-title">Visualizza il menù online</h5>
                                <p className="card-text">
                                    Visualizza il nostro menù online, consentendo di sfogliare tutte le gustose opzioni disponibili.
                                </p>
                                <button className="btn btn-primary button-primary-pers" onClick={() => window.open(MenuPdf, "_blank")}>
                                    <FaEye className="me-2" />
                                    Visualizza menù
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Menu;